import React from "react";
import { withRouter } from "react-router-dom";
import MyPointsIcon from "../../../assets/icons/my_points_icon.svg";

const PointsCard = ({ history, points }) => {
  return (
    <div
      className="card bg-white text-dark border-0 shadow rounded mb-4"
      onClick={() => history.push("/rewards/transaction")}
    >
      <div className="card-body p-3">
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column flex-grow-1">
            <small className="text-muted mb-1">MY POINTS</small>
            <h2 className="text-brand mb-0">{points}</h2>
          </div>
          <img
            src={MyPointsIcon}
            style={{ width: "75px", height: "75px" }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default withRouter(PointsCard);
